// App.js
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { Navigation } from "./components/navigation";
import { Analytics } from "@vercel/analytics/react"
import { Hero } from "./components/hero";
import { AboutSection } from "./components/AboutSection";
import { Capabilities } from './components/capabilities';
import { SelectedWork } from './components/SelectedWork';
import { Testimonials } from './components/testimonials';
import { Footer } from './components/footer';
import { Contact } from './components/contact';
import { Technologies } from './components/Technologies';
import { BackToTop } from './components/BackToTop';
import LogoDesign from './logo-design';
import SoftwareDevelopment from './software_dev';
import WebsitePackage from './webdesign';
import SheetBillsCaseStudy from './case-studies/SheetBills';
import ConceptsOfThoughtsCaseStudy from './case-studies/ConceptsOfThoughts';
import EbenezerCaseStudy from './case-studies/Ebenezer';
import PalmSuccessCaseStudy from './case-studies/PalmSuccess';
import ShelmurCarRentalsCaseStudy from './case-studies/ShelmurCarRentals';
import RomoniaCaseStudy from './case-studies/Romonia';
import AuroraCollectionCaseStudy from './case-studies/AuroraCollection';

function ScrollToHash() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    if (pathname !== '/' || !hash) return
    const id = hash.replace('#', '')
    if (!id) return
    const frame = requestAnimationFrame(() => {
      const el = document.getElementById(id)
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    })
    return () => cancelAnimationFrame(frame)
  }, [pathname, hash])
  return null
}

function App() {
  const [heroVisible, setHeroVisible] = useState(true);

  return (
    <Router>
      <ScrollToHash />
      <main className="min-h-screen">
        <Navigation setHeroVisible={setHeroVisible} />
        <Analytics />
        <Routes>
          <Route path="/" element={
            <>
              <Hero visible={heroVisible} />
              <Technologies/>
              <AboutSection />
              {/* <WhatsAppFloat phoneNumber="18763932065" /> */}
              
             
              <BackToTop/>
              <Capabilities />
              <SelectedWork />
              <Testimonials/>
              <Contact/>
              <Footer/>
            </>
          } />
          <Route path='/logo-design' element={
            <>
              <LogoDesign/>
            </>
          } />
          <Route path='/software_dev' element={
            <>
              <SoftwareDevelopment/>
            </>
          } />
          <Route path='/webdesign' element={
            <>
              <WebsitePackage/>
            </>
          } />
          <Route path="/case-studies/sheetbills" element={<SheetBillsCaseStudy />} />
          <Route path="/case-studies/concepts-of-thoughts" element={<ConceptsOfThoughtsCaseStudy />} />
          <Route path="/case-studies/ebenezer" element={<EbenezerCaseStudy />} />
          <Route path="/case-studies/palm-success" element={<PalmSuccessCaseStudy />} />
          <Route path="/case-studies/shelmur-car-rentals" element={<ShelmurCarRentalsCaseStudy />} />
          <Route path="/case-studies/romonia" element={<RomoniaCaseStudy />} />
          <Route path="/case-studies/aurora-collection" element={<AuroraCollectionCaseStudy />} />
        </Routes>
      </main>
    </Router>
  );
}

export default App;